<template>
    <div class="card text-black bg-white">
      <div class="card-header" v-html="title"></div>
      <div class="card-body">
          <div class="form-group" v-for="f in formData" v-bind:key="f.name">
            <div class="row" v-if="normalInputs.includes(f.type)" :class="f.class+'-container'">
                <label class="col-form-label" :for="f.column">{{f.name}}</label>
                <input
                  v-if="f.type != 'textarea' && f.type != 'editor'"
                  :type="f.type"
                  :required="f.required ? '' : false"
                  :placeholder="f.placeholder"
                  v-model="formBack[f.column]"
                  :id="f.column"
                  :class="f.class ? f.class : 'form-control'"
                  disabled
                />
                <textarea
                  v-else-if="f.type == 'textarea' || f.type == 'editor'"
                  :required="f.required ? '' : false"
                  :placeholder="f.placeholder"
                  v-model="formBack[f.column]"
                  :id="f.column"
                  :class="f.class ? f.class : 'form-control'"
                  disabled
                ></textarea>
            </div>
          </div>
      </div>
    </div>
</template>
<script>
export default {
  name: "DynamicValues",
  props: {
    hidden: {
      default: "",
    },
    values: {
      type: Object,
      default() {
        return {
          name: "This is my name",
          text: "This is my Text",
          editor: "<p>This is my HTML Editor Data</p>",
          tags: ["this are my default tags", "my subtags"],
        };
      },
    },
    form: {
      type: Array,
      default() {
        return [
          {
            name: "Name",
            placeholder: "Please Write Your Name...",
            class: "form-control",
            column: "name",
            type: "text",
            value: "test",
          },
          {
            name: "Name Two",
            placeholder: "Please Write Your Name...",
            class: "form-control",
            column: "text",
            type: "textarea",
            value: "Text Area",
          },
          {
            name: "Name Three",
            class: "form-control",
            column: "editor",
            type: "editor",
            value: "Text Area",
          },
          {
            name: "Tags",
            class: "form-control",
            type: "tag",
            column: "tags",
            subColumn: "tag",
            autocomplete: ["text", "and data", 1, 2, "and three", "etcutra"],
            placeholder: "Write your tags",
            addOnlyFromAutocomplete: false,
          },
          {
            name: "Select One User",
            items: [
              {
                name: "User 1",
                id: 1,
              },
              {
                name: "User 2",
                id: 2,
              },
            ],
            show: "name",
            value: "id",
            type: "selectbox",
            column: "user",
            placeholder: "Please Select Your Users",
          },
          {
            name: "Select Multiple Users",
            items: [
              {
                name: "User 1",
                id: 1,
              },
              {
                name: "User 2",
                id: 2,
              },
              {
                name: "User 3",
                id: 3,
              },
            ],
            show: "name",
            value: "id",
            column: "users",
            type: "selectbox",
            placeholder: "Please Select Your Users",
            multipleSelect: true,
            closeOnSelect: false,
          },
          {
            name: "Select Date",
            column: "date",
            type: "date",
            placeholder: "Select Date",
            class: "myClass",
          },
          {
            name: "Select Color",
            column: "color",
            type: "color",
            placeholder: "Select color",
            class: "myClass",
          },
        ];
      },
    },
    title: {
      type: String,
      default: "Your Title",
    },
    button: {
      type: Object,
      default() {
        return {
          title: "My Button",
          class: "btn btn-success btn-block",
        };
      },
    },
    theme: {
      type: String,
      default: "dark",
    },
  },
  model: {
    prop: "hidden",
    event: "update",
  },
  components: {
  },
  data() {
    return {
      formBack: [],
      formData: this.form,
      normalInputs: [
        "text",
        "email",
        "checkbox",
        "radio",
        "password",
        "textarea",
        "file",
      ],
    };
  },
  created() {
    this.formBack = this.values;
    this.fixFormData();
  },
  methods: {
    action() {
      this.$emit("save", this.formBack);
    },
    /**
     * fix form data to match our needs
     */
    fixFormData() {
      // this.formData = this.formData.map(item => {
      //     if(item.autocomplete != undefined){
      //         item.autocomplete = item.autocomplete.map(i => {
      //             return String(i);
      //         });
      //     }
      //     return item;
      // });
    },
    /**
     * filter data for autocomplete
     */
    filterData(items, text) {
      text = String(text);
      let newText = text ? text.toLowerCase() : "";
      return items.filter((item) => {
        return String(item).toLowerCase().indexOf(newText) !== -1;
      });
    },
  },
  computed: {},
  watch: {
    formBack: {
      handler() {
        this.$emit("update", this.formBack);
      },
      deep: true,
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/plugins/dynamicsValue.vue